export function getSharedValue(store, key) {
    return getStoreValue(store, key.id, function () { return key.defaultValue; });
}
export function getCollectionValue(collection, indexKey, key) {
    return getStoreValue(collection, key, indexKey.defaultKeyValue);
}
function getStoreValue(store, key, defaultValue) {
    var value = store.getValue(key);
    if (defaultValue && (value === null || value === undefined)) {
        var newValue = defaultValue(key);
        if (newValue !== value) {
            value = newValue;
            store.setValue(key, value);
        }
    }
    return value;
}
export function getValuesFromCollection(collection, key, keys) {
    var values = {};
    for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
        var valueKey = keys_1[_i];
        values[valueKey] = getCollectionValue(collection, key, valueKey);
    }
    return values;
}
//# sourceMappingURL=shared-store-reader.js.map